/*:: type PropertyInitArgs = {
  id: ?string,
  subdomain: string,
  status: 'test' | 'live',
  name: string,
  logoImage: ?string,
  profileImage: ?string,
  splashImage: ?string,
  logoStandardImageUrl: ?string,
  profileImageUrl: ?string,
  splashStandardImageUrl: ?string,
  eventDestinationWebhook?: ?Array<string>,
  settings?: ?Array<Object>
};*/

class Property {
  constructor({
    /*: PropertyInitArgs*/

    id,
    subdomain,
    status,
    name,
    logoImage,
    profileImage,
    splashImage,
    logoStandardImageUrl,
    profileImageUrl,
    splashStandardImageUrl,
    settings
  }) {
    this.id = id;
    this.subdomain = subdomain;
    this.status = status;
    this.name = name;
    this.logoImage = logoImage;
    this.profileImage = profileImage;
    this.splashImage = splashImage;
    this.logoStandardImageUrl = logoStandardImageUrl;
    this.profileImageUrl = profileImageUrl;
    this.splashStandardImageUrl = splashStandardImageUrl;
    this.settings = settings;
  }

}

module.exports = Property;